<div class="modal-header">
    <h5 class="modal-title">
        Seal Requirement Notice
    </h5>
</div>

<div class="modal-body">
    <div class="notice-card">
        <p class="notice-text">
            Did you know? Your admin can <strong>disable seal requirements</strong> for specific inventories, 
            so you won't need to skip this step in the future.
        </p>

        <a 
            class="help-link" 
            href="https://knowledge.schedule2.it/en/using-box-seals-on-select-inventories" 
            target="_blank"
            rel="noopener noreferrer"
        >
            <fa-icon [icon]="faIconName.faCircleQuestion"></fa-icon>
            Learn how to remove seal requirements
            <fa-icon 
                [icon]="faIconName.faArrowUpRightFromSquare" 
                size="sm"
            ></fa-icon>
        </a>
    </div>

    <div class="reminder-option">
        <mat-checkbox [(ngModel)]="dontRemindAgain">Don't remind me again</mat-checkbox>
    </div>
</div>

<div class="modal-footer">
    <button 
        type="button" 
        class="btn btn-save btn-lg" 
        (click)="onGotItClick()"
    >Got it</button>
</div>
